import React, { Component } from 'react'
import "./Skills.scss"

export default class Skills extends Component {
    render() {
        return (
            <div id="skills">
                <h2><strong>Mes Compétences</strong></h2>
                <img className="img8" src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Unofficial_JavaScript_logo_2.svg/512px-Unofficial_JavaScript_logo_2.svg.png" width="8%" alt=""/>
                <img className="img10" src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Node.js_logo.svg/1200px-Node.js_logo.svg.png" width="10%" alt=""/>
                <img className="img10" src="https://upload.wikimedia.org/wikipedia/commons/1/10/CSS3_and_HTML5_logos_and_wordmarks.svg" width="10%" alt=""/>
                <img className="img10" src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/1280px-React-icon.svg.png" width="10%" alt=""/>
                <img className="img10" src="https://upload.wikimedia.org/wikipedia/commons/4/49/Redux.png" width="10%" alt=""/>
                <img className="img10" src="https://upload.wikimedia.org/wikipedia/fr/thumb/6/62/MySQL.svg/800px-MySQL.svg.png" width="10%" alt=""/>
                
            <div>   
                <img className="img8" src="https://icon-library.net/images/git-icon/git-icon-28.jpg" width="8%" alt=""/>
                <img className="img8" src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/Boostrap_logo.svg/220px-Boostrap_logo.svg.png" width="8%" alt=""/>
                <img className="img15" src="https://techtonica.org/static/img/Postman-logo.png" width="15%" alt=""/>
                <img className="img10" src="https://avatars3.githubusercontent.com/u/29408238?s=400&v=4" width="10%" alt=""/>
                <img className="img10" src="https://upload.wikimedia.org/wikipedia/commons/d/db/Npm-logo.svg" width="10%" alt=""/>
            </div> 

            </div>
        )
    }
}


